import z from 'zod'
import { decimalSchema } from '../../utils/schema'
import { createSodexArrayEnvelopeSchema } from '../sodexEnvelopeSchema'

const perpsUserFundingSchema = z.object({
  symbol: z.string(),
  positionID: z.number(),
  positionSide: z.string(),
  fundingFee: decimalSchema,
  feeCoin: z.string(),
  timestamp: z.number(),
})

export const responseSchema = createSodexArrayEnvelopeSchema(
  perpsUserFundingSchema,
)
